import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { RuleAPIService } from 'app/api/rule.api.service';
import { parseErrorMessage } from 'app/utils/callstate';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import {
    RuleActions,
    RuleActionTypes,
    RuleCancelled,
    RuleEntryCreateCancelled,
    RuleEntryCreated,
    RuleEntryCreateRequested,
    RuleEntryDeleteCancelled,
    RuleEntryDeleted,
    RuleEntryDeleteRequested,
    RuleEntryUpdateCancelled,
    RuleEntryUpdated,
    RuleEntryUpdateRequested,
    RuleLoaded,
    RuleRequested,
} from './rule.actions';

@Injectable()
export class RuleEffects {

    @Effect()
    loadRule$ = this.actions$.pipe(
        ofType<RuleRequested>(RuleActionTypes.RuleRequested),
        mergeMap(action => {
            // tslint:disable-next-line: no-shadowed-variable
            const { companyId, key, filter } = action.payload;
            return this.ruleApiService
                .Rule(companyId, key, filter)
                .pipe(
                    map(rule => new RuleLoaded({ rule })),
                    catchError(error => {
                        const errorMessage = parseErrorMessage(error);
                        return of(new RuleCancelled({ errorMessage }));
                    })
                );
        })
    );

    @Effect()
    createRule$ = this.actions$.pipe(
        ofType<RuleEntryCreateRequested>(RuleActionTypes.RuleEntryCreateRequested),
        mergeMap(action => {
            return this.ruleApiService
                .CreateRuleEntry(action.payload.input)
                .pipe(
                    map(entry => new RuleEntryCreated({ entry })),
                    catchError(error => {
                        const errorMessage = parseErrorMessage(error);
                        return of(new RuleEntryCreateCancelled({ errorMessage }));
                    })
                );
        })
    );

    @Effect()
    deleteRule$ = this.actions$.pipe(
        ofType<RuleEntryDeleteRequested>(RuleActionTypes.RuleEntryDeleteRequested),
        mergeMap(action => {
            return this.ruleApiService
                .DeleteRuleEntry(action.payload.input)
                .pipe(
                    map(entry => new RuleEntryDeleted({ entry })),
                    catchError(error => {
                        const errorMessage = parseErrorMessage(error);
                        return of(new RuleEntryDeleteCancelled({ errorMessage }));
                    })
                );
        })
    );

    @Effect()
    updateRule$ = this.actions$.pipe(
        ofType<RuleEntryUpdateRequested>(RuleActionTypes.RuleEntryUpdateRequested),
        mergeMap(action => {
            return this.ruleApiService
                .UpdateRuleEntry(action.payload.input)
                .pipe(
                    map(entry => new RuleEntryUpdated({ entry })),
                    catchError(error => {
                        const errorMessage = parseErrorMessage(error);
                        return of(new RuleEntryUpdateCancelled({ errorMessage }));
                    })
                );
        })
    );

    constructor(
        private actions$: Actions<RuleActions>,
        private ruleApiService: RuleAPIService,
    ) {}
}
